import React from 'react';
import PropTypes from 'prop-types';
import { css } from '@emotion/core';
import LinkTicketForm from './LinkTicketForm';
import PageSection from './PageSection';
import { Paragraph } from './Typography';
import { linkTicketPhrasesPropTypes } from '../proptypes/link-ticket-module';
import { vunit } from '../lib/style-helpers';
import {
  ssColorWhite,
  mediaBreakpointUpMD,
} from '../constants/style-constants';

const containerCss = css`
  padding-top: ${vunit(8)};
  padding-bottom: ${vunit(8)};

  h1 {
    color: ${ssColorWhite};
    font-size: 2.1rem;
  }
`;

const contentCss = css`
  margin: 0 auto;

  ${mediaBreakpointUpMD} {
    max-width: 460px;
  }
`;

const headingCss = css`
  margin-bottom: ${vunit(4)};
`;

const formCss = css`
  margin-top: ${vunit(4)};
`;

const formContainerCss = css`
  text-align: left;
`;

const LinkTicketModule = ({ linkTicketApiPath, redirectTo, phrases }) => (
  <PageSection theme="dark_navy" css={containerCss}>
    <div css={contentCss}>
      <div css={formContainerCss}>
        <h1 css={headingCss}>{phrases.pageTitle}</h1>
        <Paragraph>{phrases.pageDescription}</Paragraph>
        <div css={formCss}>
          <LinkTicketForm
            linkTicketApiPath={linkTicketApiPath}
            redirectTo={redirectTo}
            phrases={phrases}
          />
        </div>
      </div>
    </div>
  </PageSection>
);

LinkTicketModule.propTypes = {
  linkTicketApiPath: PropTypes.string.isRequired,
  redirectTo: PropTypes.string.isRequired,
  phrases: PropTypes.shape(linkTicketPhrasesPropTypes).isRequired,
};

export default LinkTicketModule;
